import image from 'images/devices/onyx-promotion.png';

import Keon2 from './Keon2';

const names = ['ONYX ULTRA'];

export default class OnyxUltra extends Keon2 {
  constructor(device: BluetoothDevice) {
    super(device);
    this.image = image;
  }

  static get deviceNames() {
    return names;
  }
}
